module.exports = __webpack_public_path__ + "fonts/MullerLightItalic.37bfdc19.ttf";